import auth from 'hooks/auth/reducer';

const customReducer = { auth };
export default customReducer;
